/*
 Minimal Application/Module micro-framework: an Application boots
 registered Module factories once the DOM is ready, calling each
 module's boot()/ready() lifecycle in turn.
 */

export class Module {

    constructor(app) {
        this._app = app;
    }

    boot(app) {

    }

    ready(app) {

    }

    get app() {
        return this._app;
    }

}

export class Application {

    constructor(options = {}) {
        this.options = options;
        this._factories = [];

        if (document.readyState !== "complete") {
            document.addEventListener("DOMContentLoaded", () => {
                this._factories.forEach((factory) => this._boot(factory));
            });
        }
    }

    use(factory) {
        this._factories.push(factory);

        if (document.readyState === "complete") {
            this._boot(factory);
        }
    }

    _boot(factory) {
        var module = new factory(this);

        Promise.resolve(module.boot(this)).then(() => {
            module.ready(this);
        }).catch((reason) => {
            if (reason instanceof Error) {
                console.error(reason);
            }
        });
    }

}
